import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import LinkButton from '@components/Buttons/LinkButton';
import CoreButton from '@components/Buttons/CoreButton';
export const ConnectGameButton = ({ onClick, href, target, className, disabled = false, children, paletteName, isLoading, }) => {
    return href ? (_jsx(LinkButton, { size: "lg", variant: "palette", paletteName: paletteName, href: href, className: className, onClick: onClick, target: target, loading: isLoading, isExternalLink: true, children: children })) : (_jsx(CoreButton, { type: "button", className: className, onClick: onClick, size: "lg", variant: paletteName, disabled: disabled, loading: isLoading, children: children }));
};
export default ConnectGameButton;
